export default "__VITE_ASSET__BXcX27dZ__"